// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-title[data-v-6d8574d8] {\n  font-size: 14px;\n  color: #606266;\n}\n.table[data-v-6d8574d8] {\n  height: calc(100% - 82px - 21px - 14px);\n  overflow-y: auto;\n  border-bottom: 1px solid #e8eaec;\n}\n", ""]);
// Exports
module.exports = exports;
